import React, { useEffect, useState } from "react";
import images from "../../../../Utils/importImages";
import { Button, CircularProgress, SvgIcon, TextField } from "@mui/material";
import DialCodeSelector from "../../../ReviewPages/Flights/TravellersSection/Components/DialCodeSelector";
import { Countrieslist } from "../../../../Constants/CountriesAndCodes";
import { useSelector } from "react-redux";
import Verify_and_Create from "./Verify_and_Create";
import { isValidNumber, isValidPhoneNumber } from "libphonenumber-js";
import VerifyUser from "./VerifyUser";
import { isUserExist, registerUser } from "../../../../Redux/Apis/User-Apis";

function RegisterLogin({ onClose }) {
  let [textError, setTextError] = useState("");

  let userDC = useSelector(
    (state) => state.user.UserCurrentLocationData.dial_code
  );

  let [dialCode, setDialCode] = useState(null);
  let [CountryCode, setCountryCode] = useState(null);

  const handleDialCodeChange = (newValue) => {
    setTextError("");
    setDialCode(newValue);
  };

  useEffect(() => {
    const defaultCountry = Countrieslist?.find(
      (country) => country.phone === userDC
    );

    console.log("defaultCountry is : ", defaultCountry);

    setCountryCode(defaultCountry.code);
    handleDialCodeChange(defaultCountry);
  }, []);

  let [inputText, setInputText] = useState("");
  let [activeTab, setActiveTab] = useState("email");

  let onChangeInput = (e) => {
    validateInput();
    // if(inputText.length > 1){
    // } else {
    //   setTextError("")
    // }
    setInputText(e.target.value);
  };

  function ExpandIcon(props) {
    return (
      <SvgIcon
        {...props}
        style={{ color: props.color, fontSize: props.fontSize }}
      >
        <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" />
      </SvgIcon>
    );
  }

  let [informer, setInformer] = useState("");

  const validatePhoneNumber = (phoneNumber) => {
    if (!phoneNumber) {
      setTextError("*Required");
      return false;
    } else if (!isValidPhoneNumber(phoneNumber, CountryCode)) {
      setTextError("Invalid phone number");
      return false;
    } else {
      setTextError("");
      return true;
    }
  };

  const validateEmail = (email) => {
    if (!email) {
      setTextError("Email is required");
      return false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setTextError("Invalid email address");
        return false;
      } else if (email.includes("triprizer")) {
        setTextError("Email address not allowed");
        return false;
      } else {
        setTextError("");
        return true;
      }
    }
  };

  let [userExist, setUserExist] = useState(false);

  let [btnLoading, setBtnLoading] = useState(false);
  let [requestStructure , setRequestStructure] = useState({})

  let handleSubmit = async () => {
    setBtnLoading(true);

    if (activeTab == "email") {
      let isvalid = validateEmail(inputText);

      if (isvalid == false) {
        return;
      }
    } else if (activeTab == "phone") {
      let isvalid = validatePhoneNumber(inputText);

      if (isvalid == false) {
        return;
      }
    }

    let requestToCheck = {
      type: activeTab,
      value: activeTab == "phone" ? `${dialCode.phone}-${inputText}` : inputText,
    };

    let isUserThere = await isUserExist(requestToCheck);

    console.log("isUserThere is : ", isUserThere);

    if (isUserThere && isUserThere.error == false) {
      setUserExist(isUserThere.data);

      if (isUserThere.data == false) {
        // send the register request

        let requestStruc = {};

        if (activeTab == "phone") {
          requestStruc = {
            phone: `${dialCode.phone}-${inputText}`,
            type: "basic",
            device: "web",
            created_from: CountryCode,
          };
        } else if (activeTab == "email") {
          requestStruc = {
            email: inputText,
            type: "basic",
            device: "web",
            created_from: CountryCode,
          };
        }

        setRequestStructure(requestStruc)
        // chekc the account's existance logic properly : todo monday ( form backend also)

        let resp = await registerUser(requestStruc , activeTab == "phone" ? "/register/phone" : "/register/email")

        console.log("resp is : " , resp);
        
        if (activeTab == "email") {
          setInformer("OTP has been Sent To Email");
        } else if (activeTab == "phone") {
          setInformer("OTP Sent To Phone Number via SMS");
        }

      }
    }
    setBtnLoading(false);
  };

  let validateInput = () => {
    if (activeTab == "email") {
      validateEmail(inputText);
    } else if (activeTab == "phone") {
      validatePhoneNumber(inputText);
    }
  };

  return informer == "" && userExist == false ? (
    <div className="register-login">
      <div className="header">
        <img
          src={images["user-login-icon.svg"]}
          alt=""
          className="login-icon"
        />
        <div className="title proxima_semibold color_black font22">
          Sign Up / Login
        </div>
      </div>

      <div className="switch-wrapper">
        <div
          className={`switch-tab proxima_semibold color_black font16 ${
            activeTab == "email" && "active"
          }`}
          onClick={() => {
            setActiveTab("email");
            setInputText("");
            setTextError("");
          }}
        >
          By Email
        </div>
        <div
          className={`switch-tab proxima_semibold color_black font16 ${
            activeTab == "phone" && "active"
          }`}
          onClick={() => {
            setActiveTab("phone");
            setInputText("");
            setTextError("");
          }}
        >
          By Phone
        </div>
      </div>

      <div className="input-content">
        {activeTab == "phone" && (
          <div>
            <DialCodeSelector
              size={"small"}
              width={"max-content"}
              label={""}
              value={dialCode} // Pass the selected dial code
              onChange={handleDialCodeChange} // Handle changes
              Theme={"proxima"}
              IconComponent={<ExpandIcon color={"#0057B7"} fontSize="medium" />}
            />
            {!!textError && <p style={{ marginBottom: "23px" }}></p>}
          </div>
        )}

        <TextField
          autoComplete="off"
          onBlur={validateInput} // Validate on blur
          error={!!textError}
          helperText={textError}
          value={inputText}
          onChange={onChangeInput}
          id="outlined-basic"
          label={`${
            activeTab == "email" ? "Enter Email" : "Enter Mobile Number"
          }`}
          variant="outlined"
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              fontFamily: `var(--font-family-proxima_nova-regular)`,
              fontStyle: "normal",
              fontWeight: "400",
              "&.Mui-focused": {
                color: "#0057B7", // Color when focused
              },
            },
            "& .MuiOutlinedInput-root": {
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
            },
          }}
        />
      </div>

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={!inputText || !!textError || btnLoading}
        sx={{
          width: "100%",
          backgroundColor: "#0057B7",
          color: "#fff",
          fontSize: "16px",
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          // fontWeight: "600",
          marginTop: "10px",
          textTransform: "none", // Prevents uppercase transformation
          "&:hover": { backgroundColor: "#0045A5" },
          "&:disabled": {
            backgroundColor: "#B0B0B0", // Greyed-out when disabled
            color: "#fff",
            cursor: "not-allowed",
          },
        }}
      >
        {" "}
        {btnLoading ? (
          <CircularProgress size={24} sx={{ color: "white" }} />
        ) : (
          "CONTINUE"
        )}
      </Button>

      <div className="tandc color_light-gray-black font14 proxima_regular">
        By proceeding, you agree to Stfares's{" "}
        <span className="color_endeavour">Privacy Policy, User Agreement</span>{" "}
        and <span className="color_endeavour">T&Cs</span>
      </div>
    </div>
  ) : userExist == true ? (
    <VerifyUser
      onClose={onClose}
      setUserExist={setUserExist}
      credential={activeTab == "phone" ? `${dialCode.phone}-${inputText}` : inputText}
      credentialType={activeTab}
    />
  ) : (
    <Verify_and_Create
      onClose={onClose}
      Informer={requestStructure}
      setInformer={setInformer}
      credential={activeTab == "phone" ? `${dialCode.phone}-${inputText}` : inputText}
      credentialType={activeTab}
    />
  );
}

export default RegisterLogin;
